import { Button } from "V2.0/common/button";

import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useNodesData, Handle, Position } from "@xyflow/react";
import { usePipelineBuilder } from "V2.0/HomePages/Pipelines/PipelineBuilder/PipelineBuilderProvider";
import { validateNodeConfig } from "../NodeConfigure/nodeValidation";
import { NodeUIRegistry } from "../Models/nodeUIRegistry";
import { NodeType } from "../Models/NodeType";
import {
  Node,
  NodeActions,
  NodeBadge,
  NodeBody,
  NodeHeader,
  NodeName,
  NodePorts,
} from "./Components/Node";
import AddStepAction from "./Components/AddStepAction";
import ConfigureStepAction from "./Components/ConfigureStepAction";
import DeleteStepAction from "./Components/DeleteStepAction";
import { message } from "antd";
import { useMemo } from "react";
import NodeExecutionStatusBadge from "./Components/NodeExecutionStatus";
import usePipelineNode from "./Hooks/usePipelineNode";
import { TWaitForCallbackNodeConfig } from "../Models/WaitForCallback";

export default WaitForCallbackNode;

const baseUrl = process.env.REACT_APP_API_URL;

function WaitForCallbackNode(props) {
  const { id } = props;

  const {
    data,
    onDelete,
    handleAdd,
    isExecuted,
    pipelineId,
    workspaceId,
    internalNode,
    isPanelActive,
    isPreviewMode,
    onConfigureNode,
    executedNodeStatus,
  } = usePipelineNode<TWaitForCallbackNodeConfig>(id);

  const callbackUrl = `${baseUrl}/v2/pipelinesV2/callback/${workspaceId}/${pipelineId}/${data.callbackId}`;

  const renderCopyCallbackUrl = (
    <div className="h-4 py-3 flex items-center border justify-between rounded-sm pl-2 bg-gray-100">
      <p className="text-xs ellipsis text-gray-500 flex-1 shrink-0 truncate">
        {callbackUrl}
      </p>
      <CopyToClipboard text={callbackUrl}>
        <Button
          plain
          onClick={() => message.success("Callback URL Copied")}
          className="border shrink-0"
        >
          <DocumentDuplicateIcon />
        </Button>
      </CopyToClipboard>
    </div>
  );

  const {
    label,
    color,
    icon: Icon,
  } = NodeUIRegistry[NodeType.WAIT_FOR_CALLBACK]["default"];

  const ports = ["default", "timeout"];

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
      />
      <Node status={executedNodeStatus}>
        <NodeHeader>
          <NodeBadge
            color={color}
            label={label}
            icon={<Icon className="size-4" />}
          />
          <NodeActions hideActions={isPanelActive}>
            {!isPreviewMode && <AddStepAction onAddStep={handleAdd} />}
            {(!isPreviewMode || isExecuted) && (
              <ConfigureStepAction
                onConfigureStep={() => onConfigureNode(internalNode)}
              />
            )}
            {!isPreviewMode && (
              <DeleteStepAction onDeleteStep={() => onDelete(internalNode)} />
            )}
          </NodeActions>
        </NodeHeader>
        <NodeBody>
          <NodeName name={data.name} />
          {!isPreviewMode && renderCopyCallbackUrl}
          {isExecuted && (
            <NodeExecutionStatusBadge status={executedNodeStatus} />
          )}
        </NodeBody>
      </Node>
      <NodePorts ports={ports} />
    </>
  );
}
